export default function AuthLayout({ children }) {
  return (
    <div
      className="auth-layout"
      style={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        position: "relative",
      }}
    >
      {/* You can add a logo/header here if you want */}
      {children}
    </div>
  );
}
